import { render, staticRenderFns } from "./productBarcodeSkeleton.vue?vue&type=template&id=654da7cf&scoped=true"
import script from "./productBarcodeSkeleton.vue?vue&type=script&lang=js"
export * from "./productBarcodeSkeleton.vue?vue&type=script&lang=js"
import style0 from "./productBarcodeSkeleton.vue?vue&type=style&index=0&id=654da7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654da7cf",
  null
  
)

export default component.exports